module.exports = __webpack_public_path__ + "img/logo.2be88d31.png";